import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { PermissionService } from '@core/services/permission/permission.service';
import { PermissionKey } from '@core/services/permission/permission.model';

export function hasPermissionGuard(...keys: PermissionKey[]): CanActivateFn {
  return () => {
    const permissions = inject(PermissionService);
    const router = inject(Router);
    return permissions.ensureLoaded().pipe(
      map(() => (permissions.hasAny(...keys) ? true : router.createUrlTree(['/dashboard'])))
    );
  };
}

export const hasToolPermissionGuard: CanActivateFn = () => {
  const permissions = inject(PermissionService);
  const router = inject(Router);
  return permissions.ensureLoaded().pipe(
    map(() => permissions.hasAnyTool() ? true : router.createUrlTree(['/gdp']))
  );
};
